<template>
  <div>
    <base-toolbar :title="$t('ABOUT_US')"></base-toolbar>
    <v-container fluid class="pt-0">
      <v-row justify="center" class="d-none d-sm-flex">
        <v-col cols="12" md="8" class="page-title">
          {{ $t("ABOUT_US") }}
        </v-col>
      </v-row>

      <v-row justify="center" class="border-t">
        <v-col cols="12" md="8">
          <p>WedNicely is an easy to use app for your invitation card needs.</p>
          <p>
            Choose from a variety of invitation and greeting cards which suits
            your mood. Be it any occasion; a wedding, a house warming or a
            birthday party, a pretty invitation card can hype your party guests
            a lot. Our designers at WedNicely can also design a completely
            personalised card to suit your peculiar tastes within 3 days under
            your command to deliver the best invitation card you dreamt of for
            your event. E-invitation cards are a super eco-friendly and fast
            solution to help you send your cards to your friends and family from
            the comfort of your bed.
          </p>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  components: {
    BaseToolbar: () => import("@/components/BaseToolbar")
  },

  metaInfo: {
    title: "About Us",
    meta: [
      {
        vmid: "description",
        name: "description",
        content:
          "WedNicely is an easy to use app for your invitation card needs."
      }
    ]
  }
};
</script>
